module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "icons",
    staticClass: "icons-container",
    style: ({
      left: _vm.left + 'px',
      top: _vm.top + 'px'
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4359f75e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/FloatIcon.vue
// module id = 367
// module chunks = 75